import React/*, {useState}*/ from 'react';
import { findDOMNode } from 'react-dom';
import {postApi} from '../../../utils/functions';
import {UserContext} from '../../../utils/usercontext';
import EventEmitter from '../../../utils/emmiter';

import ReactPlayer from 'react-player';
import screenfull from 'screenfull';
import './video.css';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';

import { ReactComponent as PlayButton} from './images/play.svg';
import { ReactComponent as StopButton} from './images/stop.svg';

import { ReactComponent as VolumeButton0} from './images/volume-0.svg';
import { ReactComponent as VolumeButton50} from './images/volume-50.svg';
import { ReactComponent as VolumeButton100} from './images/volume-100.svg';

import { ReactComponent as TheatreOnButton} from './images/airplay-on.svg';
//import { ReactComponent as TheatreOffButton} from './images/airplay-off.svg';

import { ReactComponent as FullscreenOnButton} from './images/fullscreen.svg';
//import { ReactComponent as FullscreenOffButton} from './images/fullscreen-not.svg';

import { ReactComponent as LoadingButton} from './images/loading-svgrepo-com.svg';

import { ReactComponent as Settings} from './images/settings.svg';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


/*
  Video Status
  0 - Stopped
  1 - Loading
  2 - Playing
  3 - Buffering
*/

class VideoPlayer extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    //console.log(this.props.select);
    this.state = {
			url: null,
			playing: false,
			volume: 1,
			muted: this.iOSversion(),
			


      //status: 0,
      //uid: this.props.uid,
      //controls: false,
      //volume: 100,
      volumeshow: false,
      mute: false,
      settings: false,
      height: this.props.height,
      stream: 0,
      stream_url: 'mix365radio/index.m3u8',
      showHelp: true,
      meta: {
        '77': {},
			},
      //VideoAudio: null
    };
    this.playVideo = this.playVideo.bind(this);
    //this.retryVideo = this.retryVideo.bind(this);
    //this.stopVideo = this.stopVideo.bind(this);
    this.showControls = this.showControls.bind(this);
    this.hideControls = this.hideControls.bind(this);
    this.showVolume = this.showVolume.bind(this);
    this.hideVolume = this.hideVolume.bind(this);
    this.setVolume = this.setVolume.bind(this);
    this.muteVolume = this.muteVolume.bind(this);
    this.fullscreen = this.fullscreen.bind(this);
    this.settings = this.settings.bind(this);
    this.selectStream = this.selectStream.bind(this);
    this.videoHelp = this.videoHelp.bind(this);
    //console.log();
    //console.log("here", /(iPad|iPhone|iPod)/g.test(navigator.userAgent));
  }

  iOSversion() {
    if(navigator.vendor != null && navigator.vendor.match(/Apple Computer, Inc./) && navigator.userAgent.match(/iPhone/i) || (navigator.userAgent.match(/iPod/i))) {
      return true;
    } else if (navigator.vendor != null && navigator.vendor.match(/Apple Computer, Inc./) && navigator.userAgent.match(/iPad/i)) {
      return true;
    } else if (navigator.vendor != null && navigator.vendor.match(/Apple Computer, Inc./) && navigator.userAgent.indexOf('Safari') != -1) {
      return true;
    } else if (navigator.vendor == null || navigator.vendor != null) {
      return false;
    }
  }

  async componentDidMount() {

    //---- Video handler
		/*const VideoAudio = EventEmitter.addListener(`/clubbers/meta`, async data => {
			//console.log(data);
		}); this.setState({VideoAudio});*/


		//await this.playVideo();
		this.playVideo();
    
    //document.querySelector('video').setAttribute('oncontextmenu', "return false;")
  }

  componentWillUnmount() {
    //this.setState({status: 0});
    //if( this.player ) this.player.destroy();
    //clearTimeout(this.retry);
    //if( this.state.VideoAudio ) this.state.VideoAudio.remove();
		clearTimeout(this.retry);
  }

	ref = player => {
    this.player = player
  }


  

	async load(url) {

    //console.log("Get access token", url);

    let params = new URLSearchParams();
		params.append("channel", url);
    const x = await postApi('/api/v2/video', params);
    //console.log( x.data );

    this.setState({url: x.data.url});
  }

	playVideo() {
		//const url = this.state.url;
    let muted = this.state.muted;
    if( this.iOSversion() ) muted = true;
    this.setState({
			url: null, playing: true, muted
    }, async () => await this.load(this.props.customUrl?this.props.customUrl[0]:this.props.url));//.replace(/mix365radio\/index.m3u8|mix365radio_\d{3,4}\/index.m3u8/i,this.state.stream_url)));
	}
	handlePause = () => {
		this.setState({playing: false});
    clearTimeout(this.retry);
	}
	async retryVideo() {
		clearTimeout(this.retry);
		this.playVideo();
	}


  showControls() {
    this.setState({controls: true});
    clearTimeout(this.clearcontrols);
  }

  hideControls() {
    this.clearcontrols = setTimeout(()=>{
      this.setState({controls: false, settings: false});
    },4000);
  }

  showVolume() {
    this.setState({volumeshow: true});
    clearTimeout(this.clearvolume);
  }

  hideVolume() {
    this.clearvolume = setTimeout(()=>{
      this.setState({volumeshow: false});
    },4000);
  }

  muteVolume() {
    /*if( this.state.mute ) {
    } else {
    }
    this.player.muted = !this.state.mute;*/
    this.setState({muted: !this.state.muted});
  }

  setVolume(event) {
    try{
      let percent = 1-((event.clientY - event.target.getBoundingClientRect().top) / event.target.getBoundingClientRect().height);
      this.player.volume = Number(percent).toFixed(1);
      this.setState({volume: percent});
      if( this.state.muted ) this.muteVolume();
		} catch(error){}
  }

  fullscreen() {
    screenfull.request(findDOMNode(this.player));
  }

  settings() {
    this.setState({settings: !this.state.settings});
  }

  selectStream(stream) {
    let stream_url = 'mix365radio/index.m3u8';
    if( stream === 1 ) stream_url = 'mix365radio_1080/index.m3u8';
    if( stream === 2 ) stream_url = 'mix365radio_720/index.m3u8';
    if( stream === 3 ) stream_url = 'mix365radio_480/index.m3u8';
    
    this.setState({stream, stream_url},()=>{
      this.playVideo();
    });
    /*
    /live/mix365radio/index.m3u8
    /live/mix365radio_1080/index.m3u8
    /live/mix365radio_720/index.m3u8
    /live/mix365radio_480/index.m3u8
    */
  }

  videoHelp() {
    this.setState({showHelp: !this.state.showHelp});
  }

	handlePlay = () => {
		this.setState({playing: true});
	}
	
	handleError = (e) => {
		console.log("errro:", e);
		if( e.toString().indexOf('play') > 0 ) {
			this.setState({playing: false});
		} else {
			this.props.onError();
			this.retry = setTimeout(()=>{this.retryVideo();},5000);
		}
  }

	

  render() {
    const show_settings =
      <div className="video-settings">
        <ul>
          <li onClick={()=>this.selectStream(0)}>{this.props.height}p
            {this.state.stream===0&&
              <span className="quality-tick">&#10004;</span>
            }
          </li>
          {this.props.height>1088&&
            <li onClick={()=>this.selectStream(1)}>1080p
              {this.state.stream===1&&
                <span className="quality-tick">&#10004;</span>
              }
            </li>
          }
          {this.props.height>720&&
            <li onClick={()=>this.selectStream(2)}>720p
              {this.state.stream===2&&
                <span className="quality-tick">&#10004;</span>
              }
            </li>
          }
          {this.props.height>480&&
            <li onClick={()=>this.selectStream(3)}>480p
              {this.state.stream===3&&
                <span className="quality-tick">&#10004;</span>
              }
            </li>
          }
        </ul>
      </div>;
    return (
      
      <div className="video-panel" onMouseEnter={this.showControls} onMouseLeave={this.hideControls}>
        <div id="video-container" className="video-js-box">
          
					<ReactPlayer
						ref={this.ref}
						url={this.props.customUrl?this.props.customUrl[0]:this.state.url}
						playing={this.state.playing}
						onPause={this.handlePause}
						volume={this.state.volume}
            muted={this.props.customUrl?true:this.state.muted}
            loop={this.props.customUrl?true:false}
						onPlay={this.handlePlay}
						onError={this.handleError}
						width="100%"
						height="100%"
						config={{ attributes: { poster: this.props.uid>0?`https://mix365.co.uk/images/live/${this.props.uid}.png`:"https://mix365.co.uk/images/video_now_loading.gif" }, playsinline: true }}
            playsinline={true}
            
					/>

          {/*<video id={this.state.id}
            playsInline
            poster={(this.state.status===0&&this.props.uid>0)?`https://mix365.co.uk/images/live/${this.props.uid}.png`:"https://mix365.co.uk/images/video_now_loading.gif"}
            ref={player => (this.player = player)}
            //autoPlay={true}
            width="100%"
            controls={false}
					/>*/}
          {!this.state.playing &&
            <span className="playButton" onClick={()=>this.playVideo()}>
              <svg><PlayButton /></svg>
            </span>
          }
          {/*this.state.playing &&
            <span className="loadingButton">
              <svg><LoadingButton /></svg>
            </span>
					*/}
        </div>
        {this.state.settings && <>{show_settings}</>}
        {!this.props.customUrl && (this.state.controls || this.state.muted) &&
          <>
            <div className="video-buttons-panel">
              
              <ul className="video-buttons-right">
                <li className="video-resolution" style={{cursor: 'default'}}>
                  {this.state.stream===0&&<>{this.state.height}p</>}
                  {this.state.stream===1&&<>1080p</>}
                  {this.state.stream===2&&<>720p</>}
                  {this.state.stream===3&&<>480p</>}
                </li>
                <li>
                  <OverlayTrigger
                    
                    placement="top"
                    overlay={<Tooltip id="button-tooltip-2">Video Quality</Tooltip>}
                    >
                    <svg onClick={this.settings}><Settings /></svg>
                  </OverlayTrigger>
                </li>
                <li className="hidden">
                  <OverlayTrigger
                    className="d-none d-lg-block"
                    placement="top"
                    overlay={<Tooltip id="button-tooltip-2">Theatre Mode</Tooltip>}
                    >
                    <svg onClick={this.props.theatre}><TheatreOnButton /></svg>
                  </OverlayTrigger>
                </li>
                <li>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="button-tooltip-2">Fullscreen</Tooltip>}
                    >
                    <svg onClick={this.fullscreen}><FullscreenOnButton /></svg>
                  </OverlayTrigger>
                </li>
                
                {/*<li>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="button-tooltip-2">Video Help</Tooltip>}
                    >
                    
                    <FontAwesomeIcon icon="triangle-exclamation" className="video-warning" onClick={this.videoHelp} />
                    
                  </OverlayTrigger>
                </li>*/}
                
              </ul>
              <ul className="video-buttons-left">
                
                {this.state.playing ?
                  <li onClick={()=>this.handlePause()}><svg><StopButton /></svg></li>
                :
									<li onClick={()=>this.playVideo()}><svg><PlayButton /></svg></li>
								}
                
                <li onMouseEnter={this.showVolume} onMouseLeave={this.hideVolume} style={{position:'relative'}}>
                  {(this.state.volumeshow || this.state.muted) &&
                    <div style={{position: 'absolute', backgroundColor: '#6b0731', width: 8, height: 60, left: 14, bottom: 40, borderRadius: 4, animation: 'second_animateIt 1s linear'}}>
                      <div style={{position: 'absolute', bottom: 0, backgroundColor: '#ffffff',width: 8, height: (this.state.muted?0:this.state.volume*60), borderRadius: 4}}></div>
                      <div style={{position: 'absolute', bottom: (this.state.muted?0:this.state.volume*60-4), backgroundColor: '#ffffff',width: 14, height: 8, left:-3, borderRadius: 8}}></div>
                      <div style={{position: 'relative', width: '100%', height: '100%'}} onClick={this.setVolume}></div>
                    </div>
                  }
                  {this.state.muted ?
                    <svg onClick={this.muteVolume}><VolumeButton0 /></svg>
                  :
                    <>
                      {this.state.volume > 80 ?
                        <svg onClick={this.muteVolume}><VolumeButton100 /></svg>
                      :
                      <svg onClick={this.muteVolume}><VolumeButton50 /></svg>
                      }
                    </>
                  }
                  
                </li>
              </ul>
            </div>
          </>
        }
        
        {/*<div className="video-help-panel">
          <div className="video-help-panel-header-error">
            <Row>
              <Col>
                Stream Feeback
              </Col>
              <Col className="text-right">
                0 / 10
              </Col>
            </Row>
          </div>
          <div className="video-help-panel-body">
            There is feedback on your stream
          </div>
          <div className="video-help-panel-header">
            Audio Levels Low
          </div>
          <div className="video-help-panel-body">
            Your audio levels are low reporting at -20.5 db<br />
            Aim to to hit -6 db on your Audio Mixer.
          </div>
          <div className="video-help-panel-header-error">
            <Row>
              <Col>
                No Auido Detected
              </Col>
              <Col className="text-right">
                0 / 10
              </Col>
            </Row>
          </div>
          <div className="video-help-panel-body">
            Your audio levels are low reporting at -20.5 db<br />
            Please ensure you have an audio source included and<br />
            the audio source is playing.
          </div>
          <div className="video-help-panel-header-error">
            Auido Levels too High
          </div>
          <div className="video-help-panel-body">
            Your audio levels are too high<br />
            Please reduce your audio levels and<br />
            Aim to to hit -6 db on your Audio Mixer.
          </div>
        </div>*/}
      </div>
    )
  }
}

export default VideoPlayer;
